// extracted by mini-css-extract-plugin
export default {"container":"product-availability-message-one-dt__container___rphFX","box-design-quantity-text":"product-availability-message-one-dt__box-design-quantity-text___3Dbrq"};